import {Modal} from 'bootstrap';
import {createApp} from 'vue';
import YouTube from 'Components/embed/embeddable/youtube/clientlibs/js/Youtube.vue';
import Video from './Video.vue';

function showNativeModal(videoOptions, bs5Element) {
    const modalEl = document.getElementById('html5-video-embed-modal');
    const nativeModalContent = modalEl.content.cloneNode(true);
    bs5Element.appendChild(nativeModalContent);
    const videoElement = document.getElementById('html5-video-modal');
    const videoModal = new Modal(videoElement);
    const placeHolder = videoElement.querySelector('[data-function="html5-video-placeholder"]');
    videoElement.addEventListener('hidden.bs.modal', () => {
        videoComponent.unmount();
    });
    const props = placeHolder?.dataset;
    const translations = {
        play: props.playLabel,
        pause: props.pauseLabel,
        stop: props.stopLabel,
        forward: props.forwardLabel,
        rewind: props.rewindLabel
    };
    const componentProps = {
        translations,
        ...videoOptions
    };
    componentProps.url = videoOptions.directUrl;
    componentProps.captions = videoOptions.nativeCaptions;
    componentProps.loop = videoOptions.nativeLoop;
    const videoComponent = createApp(Video, componentProps);
    try {
        videoComponent.mount(placeHolder);
    } catch (e) {
        console.log('Video failed to mount');
    }
    videoModal.show();


}

function showModal(element, textCmpVidId, isBrightcoveLink = false, videoURL, textCmpBcAccountId) {
    const videoOptions = {
        videoId: element.dataset.bsYtVideoId ? element.dataset.bsYtVideoId : '',
        playLabel: element.dataset.bsYtPlayLabel,
        loop: "true",
        inline: element.dataset.bsYtInline || element.dataset.nativeInline === 'true',
        modalType: element.dataset.modalType,
        directUrl: videoURL || element.dataset.nativeUrl,
        nativeLoop: element.dataset.nativeLoop === 'true',
        autoplay: element.dataset.nativeAutoplay === 'true',
        muted: element.dataset.nativeMute === 'true',
        nativeTitle: element.dataset.nativeTitle,
        nativeCaptions: element.dataset.nativeCaptions
    };
    const bs5Element = document.querySelector('.amd-bs5');

    // Build modal
    let modalElement = document.getElementById('youtube-modal');
    let enableBrightcove = false;
    const enableHtml5Video = videoOptions.modalType === 'native' || textCmpVidId === 'native' || videoURL?.includes('vod.amd.com');
    if (enableHtml5Video) {
        showNativeModal(videoOptions, bs5Element);
        return;
    }
    if (!modalElement) {
        let videoTemplate = document.querySelector('#youtube-embed-modal');
        const modalContent = videoTemplate.content.cloneNode(true);
        bs5Element.appendChild(modalContent);
    }
    let videoModal;
    let videoModalElement;
    let placeHolder;
    let videoEmbedElement;
    videoModal = new Modal(document.getElementById('youtube-modal'));
    videoModalElement = document.querySelector('#youtube-modal');
    placeHolder = videoModalElement.querySelector('[data-function="youtube-video-placeholder"]');
    videoEmbedElement = videoModalElement.querySelector('.yt-embed');


    applyVideoAttr(placeHolder, videoEmbedElement, videoModalElement, videoOptions, enableBrightcove);

    const videoComponent = createApp(YouTube);
    videoComponent.provide('videoUrl', buildVideoSrc(videoOptions));
    videoComponent.provide('directVideoUrl', `https://www.youtube.com/watch?v=${videoOptions.videoId}`);
    videoComponent.provide('cookieLabel', videoEmbedElement.dataset.cmpCookieLabel);
    videoComponent.provide('playLabel', videoOptions.playLabel);
    videoComponent.provide('cookieSettingsButton', videoEmbedElement.dataset.cmpCookieSettingsButton);
    videoComponent.provide('watchOnYouTube', videoEmbedElement.dataset.cmpWatchOnYoutube);

    videoComponent.mount(placeHolder);

    videoModal.show();
    videoModalElement.addEventListener('shown.bs.modal', showCookieSettings);
    videoModalElement.addEventListener('hidden.bs.modal', () => {
        let bcVideoPlayer = placeHolder.querySelector('.video-js');
        if (bcVideoPlayer) {
            bcVideoPlayer.remove();
        }
        videoComponent.unmount();
    });
}

function applyVideoAttr(placeHolderEl, embedElement, videoElem, options, enableBrightcove = false) {
    let bgImage = `url("https://i.ytimg.com/vi/${options.videoId}/hqdefault.jpg")`;
    let playText = 'Play';
    if (options.playLabel) {
        playText = options.playLabel;
    }

    placeHolderEl.style.backgroundImage = bgImage;
}

function buildVideoSrc(options) {
    const origin = `origin=${window.location.protocol}%2F%2F${location.host.replace(':', '%3A')}`;
    const pathArray = location.pathname.split('/');
    let language = pathArray[1];
    let enableLoop = '&loop=0';
    let enableInline = '&playsinline=0';
    if (pathArray[1] === 'content' || pathArray[1] === 'editor.html') {
        language = pathArray[4];
    }
    if (options.loop === 'true') {
        enableLoop = `&loop=1&playlist=${options.videoId}`;
    }
    if (options.inline === 'true') {
        enableInline = '&playsinline=1';
    }
    return `https://www.youtube.com/embed/${options.videoId}?${origin}&hl=${language}&mute=0&autoplay=1${enableLoop}${enableInline}&enablejsapi=1&rel=0`;
}

function richTextYtLinks(links) {
    // YouTube modal links.
    links.forEach(item => {
        const isModal = item.querySelector('.yt-modal-link');
        if (isModal) {
            item.addEventListener('click', e => {
                e.preventDefault();
                const videoUrl = item.getAttribute('href');
                const isBrightcoveLink = false;
                const isHTML5Video = videoUrl.includes('vod.amd.com');
                const regexPattern = /^(https:\/\/[^.]*\.youtube\.com\/watch\?v=|https:\/\/[^.]*\.youtube\.com\/embed\/|https:\/\/youtu\.be\/)/;
                const bcVideoIdRegex = /videoId=(\d+)/;
                let linkVideoId = videoUrl.replace(regexPattern, '');
                let bcAccountId = '';
                if (isHTML5Video) {
                    linkVideoId = 'native';
                }
                showModal(item, linkVideoId, isBrightcoveLink, videoUrl, bcAccountId);
            });
        }
    });
}

function showCookieSettings() {
    let cookieLink = document.querySelector('.modal-body .ot-sdk-show-settings');
    if (cookieLink) {
        cookieLink.addEventListener('click', e => {
            let messageBackground = document.querySelector('.onetrust-pc-dark-filter');
            let settingsPrompt = document.querySelector('#onetrust-pc-sdk');
            if (messageBackground.classList.contains('ot-hide')) {
                messageBackground.classList.remove('ot-hide');
            }
            if (settingsPrompt.classList.contains('ot-hide')) {
                settingsPrompt.classList.remove('ot-hide');
            }
            messageBackground.removeAttribute('style');
            settingsPrompt.removeAttribute('style');
            settingsPrompt.style.height = "80%";
        });
    }
}

function checkThumbnailSize(linkElement) {
    return new Promise((resolve, reject) => {
        const videoID = linkElement.dataset.bsYtVideoId;
        const maxResUrl = `https://i.ytimg.com/vi/${videoID}/maxresdefault.jpg`;
        const hqResUrl = `https://i.ytimg.com/vi/${videoID}/hqdefault.jpg`;
        const img = new Image();
        img.src = maxResUrl;
        img.onload = () => {
            if (img.naturalHeight >= 360 && img.naturalWidth >= 480) {
                resolve(maxResUrl);
            } else {
                resolve(hqResUrl);
            }
        };
        img.onerror = () => {
            reject(hqResUrl);
        };
    }).catch(() => {
        return hqResUrl;
    });
}

export {showModal, richTextYtLinks, checkThumbnailSize};
